
import BreadcrumbView from "../common/breadcrumb/breadcrumb.html";
import StaffListView from "./staff-list.html";
import StaffEditView from "./staff-edit.html";
import FoldersListView from "../folders/folders-list.html";

angular.module("staff", [])

    .config(['$stateProvider', function ($stateProvider) {
        $stateProvider
            .state('staff', {
                url: "/staff",
                abstract: true,
                controller: "BreadcrumbCtrl",
                template: BreadcrumbView,
            })

            .state('staff.list', {
                url: "/list",
                controller: "StaffListCtrl",
                template: StaffListView,
                requiredPermission: ["STAFF_READ"]
            })            
            .state('staff.edit', {
                url: "/edit/:id&:is_external",
                views: {
                    '': {
                        controller: "StaffEditCtrl",
                        template: StaffEditView,
                    },
                    'foldersFiles@staff.edit': {
                        controller: "FoldersListCtrl",
                        template: FoldersListView,
                        resolve: {
                            entity_type: [function () { return "staff"; }],
                            entity_type_id: ['$stateParams', function ($stateParams) {
                                if (angular.isDefined($stateParams.id) && $stateParams.id != "") {
                                    return $stateParams.id;
                                }
                                return null;
                            }],
                            is_public: [function () { return false}]
                        }
                    }
                },
                requiredPermission: ["STAFF_READ"]
            })
    }])
;